import {
  CREATE_OR_UPDATE_TODO,
  CREATE_OR_UPDATE_TODO_SUCCESS,
  CREATE_OR_UPDATE_TODO_ERROR,
  GET_TODO,
  GET_TODO_SUCCESS,
  GET_TODO_ERROR
} from "./constants";

const initialState = {
  todo: null,
  todoLoading: false,
  todoError: null
};

function todo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_OR_UPDATE_TODO:
      return {
        ...state,
        todo: null,
        todoLoading: true,
        todoError: null
      };
    case CREATE_OR_UPDATE_TODO_SUCCESS:
      return {
        ...state,
        todo: payload,
        todoLoading: false
      };
    case CREATE_OR_UPDATE_TODO_ERROR:
      return {
        ...state,
        todo: payload,
        todoLoading: false,
        todoError: action.error
      };
    case GET_TODO:
      return {
        ...state,
        todo: null,
        todoLoading: true,
        todoError: null
      };
    case GET_TODO_SUCCESS:
      return {
        ...state,
        todo: payload,
        todoLoading: false
      };
    case GET_TODO_ERROR:
      return {
        ...state,
        todo: payload,
        todoLoading: false,
        todoError: action.error
      };
    default:
      return state;
  }
}

export default todo;